import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {retry, catchError, forkJoin, map, Observable, of, throwError } from 'rxjs';

import { HESTIA_INTERCEPTOR_SKIP_HEADER } from '@hestia/ngx-user';

import { environment } from '../../environments/environment';
import {
  CHILD_EXAMPLE_QNRS,
  DawbaRelationType,
  ISetupCarePlanSetPayload,
  PARENT_EXAMPLE_QNRS,
  TEACHER_EXAMPLE_QNRS,
} from '../models/models';

@Injectable({ providedIn: 'root' })
export class DawbaQnrInfoService {
  qnrInfoFolder = `${environment.apiUrl}@qnrinfo`;
  createDawbaUserEndpoint = `${environment.apiUrl}@setup-careplan-set`;
  constructor(private httpClient: HttpClient) {}

  createRequestHeaders = () =>
    new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set(HESTIA_INTERCEPTOR_SKIP_HEADER, 'true')
      .append(
        'Authorization',
        'Basic ' +
          btoa(
            `${environment.backendAdminUser}:${environment.backendAdminPassword}`
          )
      );

  getQnrInfoFromBackend(l: string, a: string, t: string): Observable <any> {
    let params = new HttpParams();

    // Begin assigning parameters
    params = params.append('l', l);
    params = params.append('a', a);
    params = params.append('t', t);

      return this.httpClient
      .get<any>(`${this.qnrInfoFolder}`,  {
        headers: this.createRequestHeaders(),
        params: params
      }).pipe(retry(1), catchError(this.handleError));
    

    return this.httpClient
      .get<any>(`${this.qnrInfoFolder}/${t}`,  {
        headers: this.createRequestHeaders(),
      })
      .pipe(retry(1), catchError(this.handleError));

    // We only care about patient in this check
      
      
  }
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return 'n';
  }


 
}
